var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpactNusringShortageCrisisSectionImageMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "960px",
    height: "828px",
    viewBox: "0 0 960 828",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "impact-nusring-shortage-crisis-section-image-mob") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.666197,332 C286.656096,332 333.666197,284.989899 333.666197,227 C333.666197,169.010101 286.656096,122 228.666197,122 C170.676299,122 123.666197,169.010101 123.666197,227 C123.666197,284.989899 170.676299,332 228.666197,332 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 210,
    height: 210,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.666197,332 C286.656096,332 333.666197,284.989899 333.666197,227 C333.666197,169.010101 286.656096,122 228.666197,122 C170.676299,122 123.666197,169.010101 123.666197,227 C123.666197,284.989899 170.676299,332 228.666197,332 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 210,
    height: 210,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M729.053087,380.5 C787.871413,380.5 835.553087,332.818326 835.553087,274 C835.553087,215.181674 787.871413,167.5 729.053087,167.5 C670.234761,167.5 622.553087,215.181674 622.553087,274 C622.553087,332.818326 670.234761,380.5 729.053087,380.5 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 213,
    height: 213,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M729.053087,380.5 C787.871413,380.5 835.553087,332.818326 835.553087,274 C835.553087,215.181674 787.871413,167.5 729.053087,167.5 C670.234761,167.5 622.553087,215.181674 622.553087,274 C622.553087,332.818326 670.234761,380.5 729.053087,380.5 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 213,
    height: 213,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exports",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "impact-nusring-shortage-crisis-section-image-mob"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3ECF2",
    x: 0,
    y: 92,
    width: 460,
    height: 348,
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3ECF2",
    opacity: 0.300000012,
    x: 500,
    y: 92,
    width: 460,
    height: 348,
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3ECF2",
    opacity: 0.300000012,
    x: 0,
    y: 480,
    width: 460,
    height: 348,
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3ECF2",
    x: 500,
    y: 480,
    width: 460,
    height: 348,
    rx: 24
  }), /*#__PURE__*/React.createElement("text", {
    id: "Impact-of-the-Nursin",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 40,
    fontWeight: 400,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 99.7894913,
    y: 42
  }, "Impact of the Nursing Shortage Crisis")), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    stroke: "#CDD9E0",
    mask: "url(#mask-2)",
    strokeWidth: 60,
    fillOpacity: 0,
    fill: "#D8D8D8",
    strokeDasharray: "162.75,446.2499999999997",
    transform: "translate(228.6662, 227) scale(-1, 1) rotate(180) translate(-228.6662, -227)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    stroke: "#E58335",
    mask: "url(#mask-4)",
    strokeWidth: 60,
    fillOpacity: 0,
    fill: "#D8D8D8",
    strokeDasharray: "162.75,446.2499999999997",
    transform: "translate(228.6662, 227) rotate(180) translate(-228.6662, -227)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("text", {
    id: "62%",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 47.1,
    fontWeight: 400,
    "line-spacing": 66,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 190.809944,
    y: 222
  }, "62"), /*#__PURE__*/React.createElement("tspan", {
    x: 248.224844,
    y: 222,
    fontSize: 30.6
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "$-40,000+",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 54,
    fontWeight: 500,
    "line-spacing": 66,
    fill: "#31AC9E"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 96,
    y: 616
  }, "$ 40,000"), /*#__PURE__*/React.createElement("tspan", {
    x: 338.544,
    y: 617.914185,
    fontSize: 44
  }, "+")), /*#__PURE__*/React.createElement("text", {
    id: "$-6.5M+",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 54,
    fontWeight: 500,
    "line-spacing": 66,
    fill: "#306C97"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 625,
    y: 616
  }, "$ 6.5M"), /*#__PURE__*/React.createElement("tspan", {
    x: 810.52,
    y: 617.914185,
    fontSize: 44
  }, "+")), /*#__PURE__*/React.createElement("use", {
    id: "Oval-Copy-2",
    stroke: "#D9E5E7",
    mask: "url(#mask-6)",
    strokeWidth: 60,
    fillOpacity: 0,
    fill: "#D8D8D8",
    strokeDasharray: "277.8426415806703,454.1658564299416",
    transform: "translate(729.0531, 274) scale(-1, 1) rotate(240) translate(-729.0531, -274)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Oval-Copy",
    stroke: "#50985E",
    mask: "url(#mask-8)",
    strokeWidth: 60,
    fillOpacity: 0,
    fill: "#D8D8D8",
    strokeDasharray: "71.24170296940265,641.1753267246238",
    transform: "translate(729.0531, 274) rotate(128) translate(-729.0531, -274)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "18.7%",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 47.1,
    fontWeight: 400,
    "line-spacing": 66,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 679.273032,
    y: 269
  }, "18.7"), /*#__PURE__*/React.createElement("tspan", {
    x: 763.534932,
    y: 269,
    fontSize: 30.6
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "Hospitals-in-the-U.S",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 32,
    fontWeight: "normal",
    "line-spacing": 50,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40.0625,
    y: 290
  }, "Hospitals in the U.S. report "), /*#__PURE__*/React.createElement("tspan", {
    x: 51.390625,
    y: 340
  }, "having a nursing vacancy "), /*#__PURE__*/React.createElement("tspan", {
    x: 80.765625,
    y: 390
  }, "rate higher than 7.5%")), /*#__PURE__*/React.createElement("text", {
    id: "Average-turnover-rat",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 32,
    fontWeight: "normal",
    "line-spacing": 50,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 578.304688,
    y: 337
  }, "Average turnover rate")), /*#__PURE__*/React.createElement("text", {
    id: "Average-cost-of-turn",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 32,
    fontWeight: "normal",
    "line-spacing": 50,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19.9765625,
    y: 679
  }, "Average cost of turnover for a "), /*#__PURE__*/React.createElement("tspan", {
    x: 149.171875,
    y: 729
  }, "bedside RN")), /*#__PURE__*/React.createElement("text", {
    id: "Annual-cost-of-turno",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 32,
    fontWeight: "normal",
    "line-spacing": 50,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 540.070312,
    y: 679
  }, "Annual cost of turnover for "), /*#__PURE__*/React.createElement("tspan", {
    x: 613.210938,
    y: 729
  }, "average hospital"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactNusringShortageCrisisSectionImageMob);
export default __webpack_public_path__ + "static/media/impact-nusring-shortage-crisis-section-image-mob.78bd8fb3b47c1abbc8d7aab54ac4eb8d.svg";
export { ForwardRef as ReactComponent };